import * as yup from 'yup';
var Validation = /** @class */ (function () {
    function Validation() {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: yup.object({
                url: yup.string().required("Website url is required"),
                industry: yup.string().required("Industry is required"),
                description: yup.string().required("Description is required"),
                isOfferMembershipArea: yup.boolean().optional(),
                testUserId: yup.string().when('isOfferMembershipArea', function (isOfferMembershipArea) {
                    if (isOfferMembershipArea) {
                        return yup.string().required("User ID for the test account is required");
                    }
                    return yup.string().optional();
                }),
                testPassword: yup.string().when('isOfferMembershipArea', function (isOfferMembershipArea) {
                    if (isOfferMembershipArea) {
                        return yup.string().required("User password for the test account is required");
                    }
                    return yup.string().optional();
                })
            })
        });
        Object.defineProperty(this, "initialTouch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                url: true,
                industry: true,
                description: true
            }
        });
    }
    return Validation;
}());
export { Validation };
